var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCf7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630",
    transform: "translate(-127 -1546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    transform: "translate(127 1546)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "settings_4_",
    "data-name": "settings (4)",
    transform: "translate(131 1550)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M37.324,15.624H34.963a15.331,15.331,0,0,0-1.328-3.194l1.675-1.675a2.6,2.6,0,0,0,0-3.68L32.854,4.618a2.6,2.6,0,0,0-3.68,0L27.5,6.293A15.324,15.324,0,0,0,24.3,4.965V2.6A2.612,2.612,0,0,0,21.7,0H18.228a2.612,2.612,0,0,0-2.6,2.6V4.965A15.324,15.324,0,0,0,12.43,6.293L10.755,4.618a2.6,2.6,0,0,0-3.68,0L4.618,7.074a2.6,2.6,0,0,0,0,3.68L6.293,12.43a15.335,15.335,0,0,0-1.328,3.194H2.6a2.612,2.612,0,0,0-2.6,2.6V21.7a2.612,2.612,0,0,0,2.6,2.6H4.965A15.331,15.331,0,0,0,6.293,27.5L4.618,29.174a2.6,2.6,0,0,0,0,3.68L7.074,35.31a2.6,2.6,0,0,0,3.68,0l1.675-1.675a15.324,15.324,0,0,0,3.194,1.328v2.361a2.612,2.612,0,0,0,2.6,2.6H21.7a2.612,2.612,0,0,0,2.6-2.6V34.963A15.324,15.324,0,0,0,27.5,33.635l1.675,1.675a2.6,2.6,0,0,0,3.68,0l2.456-2.456a2.6,2.6,0,0,0,0-3.68L33.635,27.5A15.335,15.335,0,0,0,34.963,24.3h2.361a2.612,2.612,0,0,0,2.6-2.6V18.228A2.612,2.612,0,0,0,37.324,15.624ZM19.964,26.04a6.076,6.076,0,1,1,6.076-6.076A6.083,6.083,0,0,1,19.964,26.04Z",
    fill: "#ffc222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M275.964,18.228V21.7a2.612,2.612,0,0,1-2.6,2.6H271a15.332,15.332,0,0,1-1.328,3.194l1.675,1.675a2.6,2.6,0,0,1,0,3.68L268.89,35.31a2.6,2.6,0,0,1-3.68,0l-1.675-1.675a15.324,15.324,0,0,1-3.194,1.328v2.361a2.612,2.612,0,0,1-2.6,2.6H256V26.04a6.076,6.076,0,0,0,0-12.152V0h1.736a2.612,2.612,0,0,1,2.6,2.6V4.965a15.325,15.325,0,0,1,3.194,1.328l1.675-1.675a2.6,2.6,0,0,1,3.68,0l2.456,2.456a2.6,2.6,0,0,1,0,3.68l-1.675,1.675A15.337,15.337,0,0,1,271,15.624h2.361A2.612,2.612,0,0,1,275.964,18.228Z",
    transform: "translate(-236.036)",
    fill: "#f99c00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCf7);
export default __webpack_public_path__ + "static/media/cf7.bee56268493ec3e7eb0ee9734d3460dd.svg";
export { ForwardRef as ReactComponent };